module.exports = __webpack_public_path__ + "static/HDBR-Cotidiano-3-c199b7a4dbb9968f8e7960f7bb37d685.jpg";